import find from 'lodash/find'
export default {
  setHome (state, home) {
    state.home = home
  },
  setIsSavedReport (state, status) {
    state.savedReport = status
  },
  setIsSharedReport (state, status) {
    state.sharedReport = status
  },
  setFeedbackReport (state, status) {
    state.feedbackReport = status
  },
  setLinkedReport (state, status) {
    state.linkedReport = status
  },
  pushHistory (state, location) {
    if (location.component.hasOwnProperty('default')) {
      location.component = location.component.default
    }
    state.stack.push(location)
  },
  popHistory (state) {
    state.stack.pop()
  },
  clearHistory (state) {
    state.stack = []
  },
  setDirection (state, direction) {
    state.direction = direction
  },
  setCustomerId (state, customer_id) {
    state.customer.id = customer_id
  },
  setViews (state, views) {
    state.views = views
  },
  setProjectName (state, name) {
    state.project.name = name
  },
  setCurrentView (state, currentView) {
    state.currentView = currentView
  },
  updateCurrentViewPreviewImage (state, image) {
    const view = find(state.views, {id: state.currentView.id})
    view.preview_image = image
    state.currentView.preview_image = image
  },
  updateCurrentViewProperty (state, { property, value }) {
    if (state.currentView) {
      state.currentView[property] = value
    }
  },
  updateCurrentViewIcon (state, icon) {
    const view = find(state.views, {id: state.currentView.id})
    view.icon = icon
    state.currentView.icon = icon
  },
  clearViews (state) {
    state.views = []
  },
  clearCurrentView (state) {
    state.currentView = {}
    state.savedReport = false
    state.sharedReport = false
    state.feedbackReport = false
    state.linkedReport = false
  },
  reset (state) {
    state.stack = []
    state.home = null
    state.direction = 'right'
    state.views = []
    state.currentView = {}
    state.savedReport = false
    state.sharedReport = false
    state.feedbackReport = false
    state.linkedReport = false
    state.customer = {
      created_at: null,
      email: '',
      fax: '',
      faxExt: '',
      hasFileSharing: false,
      hasPowerPoints: false,
      hasReferenceFiles: false,
      id: null,
      inactive: null,
      maintenance_mode: null,
      name: '',
      phone: '',
      phoneExt: '',
      updated_at: null,
      trendCategories: null,
      users: null,
      website: ''
    }
    state.project = {
      id: null,
      customer_id: null,
      name: '',
      tag_line: '',
      project_description: '',
      order: null,
      has_filters: null,
      has_time_frame: null,
      published: null,
      type: '',
      type_id: null,
      maintenance_mode: false,
      preview_image: null
    }
  }
}
